import { useState, useEffect, useContext } from 'react';

import { PracticeReseveContext } from '../../PracticeReseveContext';


// 無料回数/チケット不足
function PracticeReserveTicketLess() {

  const { lessTicketCount } = useContext(PracticeReseveContext);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
      <div className="alert alert-warning" style={{ fontSize: '16px', textAlign: 'center' }}>
        <strong>
          受講に必要なチケットが
          <span className="font_num" style={{ fontSize: '20px', color: 'red' }}>
            {lessTicketCount}枚
          </span>
          不足しています。
        </strong>
        <br />
        <a href="/settlement/ticket" className="btn btn-warning btn-lg" style={{ marginTop: '8px' }}>
          チケットを購入する
        </a>
      </div>
    </div>
  );
}
  
export default PracticeReserveTicketLess;